import { FC, useEffect } from 'react';
import CoreScroll from '@nrk/core-scroll/jsx';

import { Episodes } from '@rikstv/play-common/src/components/coverPage/episodes/Episodes';
import { CoreScrollClass } from '@rikstv/play-common/src/components/swimlane/swimlaneScroller/SwimlaneScroller';
import { getLogger } from '@rikstv/play-common/src/utils/logger/logger';
import { Gutter, Loader } from '@rikstv/shared-components';

import { GenericSeason } from '../../contentStack.types';
import { OnSelectVariant } from '../../hooks/useContentStackEventHandlers';

import { useSeasonEpisodes } from './useSeasonEpisodes';

import seriesStyles from './GenericSeriesSection.module.css';

const logger = getLogger('[EpisodeList]');

type EpisodeListProps = {
  selectedSeason: GenericSeason;
  onClickVariant: OnSelectVariant;
};
export const EpisodeList: FC<EpisodeListProps> = ({ selectedSeason, onClickVariant: _ }) => {
  const { episodes, isLoading, pageNr, hasMoreEpisodes, loadMoreEpisodes } = useSeasonEpisodes(selectedSeason);
  const selectedEpisodeIndex = selectedSeason.defaultSelectedEpisodeIndex;
  const selectedEpisodeId = selectedEpisodeIndex !== undefined ? episodes[selectedEpisodeIndex]?.id : undefined;

  useEffect(() => {
    logger.log('episodes', { episodes, pageNr });
    // Scroll to selected episode (but only for first batch/page of episodes)
    if (episodes.length > 0 && pageNr === 1) {
      const handle = setTimeout(() => {
        const $scroller = document.querySelector(`.${CoreScrollClass}`) as unknown as
          | (HTMLElement & CoreScroll['el'])
          | undefined;
        const $episode = $scroller?.querySelector(`.${seriesStyles.selectedEpisode}`) ?? $scroller?.items[0];

        if ($scroller && $episode instanceof HTMLElement) {
          $scroller.scroll($episode);
        }
      }, 150);
      return () => clearTimeout(handle);
    }
  }, [episodes, pageNr]);

  if (!episodes[0]) {
    return null;
  }

  return (
    <Gutter>
      {isLoading && <Loader size="large" />}
      <Episodes
        episodes={episodes}
        selectedEpisodeId={selectedEpisodeId}
        seasonLabel={selectedSeason.label}
        pagination={{ hasMoreEpisodes, loadMoreEpisodes }}
      />
    </Gutter>
  );
};
